import AuthService from './AuthService.js';

/**
 * Factory functions to create configured AuthService instances for different apps
 */

// Client app auth service
export const createClientAuthService = () => {
    return new AuthService({
        appType: 'client',
        requireAdminRole: false,
        enableRegistration: true,
        reduxIntegration: true
    });
};

// Admin app auth service
export const createAdminAuthService = () => {
    return new AuthService({
        appType: 'admin',
        requireAdminRole: true,
        enableRegistration: false,
        reduxIntegration: false
    });
};

// ContentMakers app auth service
export const createContentMakersAuthService = () => {
    return new AuthService({
        appType: 'contentMakers',
        requireAdminRole: false,
        enableRegistration: true,
        reduxIntegration: true
    });
};

// Generic factory function
export const createAuthService = (config) => {
    return new AuthService(config);
};

// Default exports for each app type
export const clientAuth = createClientAuthService();
export const adminAuth = createAdminAuthService();
export const contentMakersAuth = createContentMakersAuthService();